<template>
<div class="animated fadeIn mt-5">
  <b-card v-if="loading" class="text-center">
    <i class="fa fa-spinner fa-spin fa-4x"></i>
  </b-card>
  <div v-if="!loading">

    <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
      <b-card>
        <div slot="header">
          <strong>Importar Famílias</strong>
        </div>
        <b-form-group label="Importar do ficheiro excel">          
              <codemirror v-model="import_data" :options="cmOptions" />
        </b-form-group>

        <div slot="footer">
          <div class="row">
            <div class="col-sm-3">
              <router-link
                :to="{ name: baseRoute + '.index' }"
                size="sm"
                variant="danger"
                ><i class="fa fa-ban"></i> Cancelar</router-link
              >
            </div>
            <div class="col-sm-9 text-right">
              <b-button type="submit" size="sm" variant="primary"
                ><i class="fa fa-save"></i> Importar</b-button
              >
            </div>
          </div>
        </div>
      </b-card>
    </form>

  </div>
</div>
</template>

<script>
import States from '@/components/Lists.js'
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/mode/xml/xml.js";
export default {
  name: 'FamiliesEdit',
  props: ['id'],
  components: { codemirror },
  data() {
    return {
      url: 'families/import',
      loading: true,
      states: States,
      baseRoute: 'families',
      import_data: '',
      cmOptions: {
        tabSize: 4,
        mode: "text",
        theme: "material",
        lineNumbers: true,
        line: true,
        // more CodeMirror options...
      },
    }
  },
  computed: {

  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.import_data
      }
      this.loading = true
      this.axios.post(this.url, data).then(response => {
        // var imported = response.data.data
        this.loading = false
        this.$bvToast.toast('Foram importadas ' + response.data.imported + ' famílias', { autoHideDelay: 5000, variant: 'success', solid: true})
        this.import_data = '';
      })
    }
  },
  created() {
    this.loading = false
  }
}
</script>
